import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { User } from './user';
import { UserService } from './user.service';
import { Role } from './role';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';

@Component({
    templateUrl: 'user-detail.component.html',
})
export class UserDetailComponent implements OnInit {
    @Input() user: User;
    @Output() close = new EventEmitter();
    error: any;
    navigated = false; // true if navigated here
    errorResponse: any;
    success: any;
    roles: Role[];
    storedRoles: Role[];
    storedStatus: number;
    isFirst: any;
    isStatusFirst: any;
    foundIt: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    constructor(
        private toasterService: ToasterService,
        private router: Router,
        private _service: NotificationsService,
        private userService: UserService,
        private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.getRoles();
        this.route.params.forEach((params: Params) => {
            const userId = +params['userId'];
            this.navigated = true;
            this.userService.getUser(userId)
                .then(user => this.user = user)
                .catch(error => this.errorHandler(error));


        });
        this.storedRoles = [new Role(null)];
        this.isFirst = true;
        this.isStatusFirst = true;
        this.storedStatus = 0;
    }


    createNotification() {
        this.toasterService.pop(this.notificationType, this.notificationTitle, this.notificationContent);
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }

    getRoles() {
        return this.userService
            .getRoles()
            .then(res => {
                this.roles = res.user_roles;
                this.roles = this.roles.filter(r => r.role_name != 'User');

            })
            .catch(error => this.errorHandler(error));
    }

    save1(user: User, isValid: boolean) {
        // call API to save customer
        if (isValid == true) {
            this.submitting = true;
            if (this.isFirst == false) {
                user.user_roles = this.storedRoles;
            } else {
                user.user_roles = this.user.user_roles;
            }
            if (this.isStatusFirst == false) {

                user.status = this.storedStatus;
            } else {
                user.status = this.user.status;
            }
            this.save(user);
        }
    }

    save(user: User) {
        this.userService
            .updateUser(user)
            .then(user => {
                this.user = user; // saved hero, w/ id if new
                this.goBack(user);
            })
            .catch(error => this.errorHandler(error));
    }
    goBack(savedUser: User = null) {
        this.close.emit(savedUser);
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/parrot']);
        }
    }
    public activeStatus = [
        { value: 0, display: 'Inactive' },
        { value: 1, display: 'Active' },
    ];

    checkRole(role: Role) {
        this.foundIt = false;
        if (this.isFirst == true) {
            this.storedRoles.splice(0, 1);
            for (const item of this.user.user_roles) {
                this.storedRoles.push(item);
            }
            this.isFirst = false;
            for (const item of this.storedRoles) {
                if (item.role_name == role.role_name) {
                    this.storedRoles.splice(this.storedRoles.indexOf(item), 1);
                    this.foundIt = true;
                }
            }
            if (this.foundIt == false) {
                this.storedRoles.push(role);
            }
        }
        else {
            for (const item of this.storedRoles) {
                if (item.role_name == role.role_name) {
                    this.storedRoles.splice(this.storedRoles.indexOf(item), 1);
                    this.foundIt = true;
                }
            }
            if (this.foundIt == false) {
                this.storedRoles.push(role);
            }
        }

    }

    checkExistingRole(role: Role) {
        for (const item of this.user.user_roles) {
            if (item.role_name == role.role_name) {
                return true;
            }
        }
        return false;
    }

    checkExistingStatus() {
        if (this.user.status == 1) {
            return true;
        }
        return false;
    }

    checkStatus() {
        if (this.isFirst == true) {
            this.storedStatus = this.user.status;
            this.isStatusFirst = false;
        }

        if (this.storedStatus == 0) {
            this.storedStatus = 1;
        }
        else {
            this.storedStatus = 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/user/user-detail.component.ts